// PARAQTA — animateNum: counter элементіне жаңа мән + .updated class
// 1.5 сек кейін .updated class алынады (CSS keyframe-мен анимация).

export function animateNum(id, val) {
  const el = document.getElementById(id);
  if (!el) return;
  el.textContent = val;
  el.classList.add('updated');
  setTimeout(() => el.classList.remove('updated'), 1500);
}
